import DepartmentsService from "../services/departments.sevice";
import UsersService from "../services/users.sevice";

const state = {
	fromDepId: null,
	departments: [],
	departmentsWithRequisite: [],
	depChildResponse: '',
	notAllowedErrorDep: false,
	deleteDepErrorMessage: '',
	name: '',
	id: '',
	addDepError: false,
	addDepErrorMessages: [],
	myDepartments: [],
	wholesaleDepartments: [],
	transferPermittedDepartments:[]
};

const getters = {
	getDepartments: (state) => {
		return state.departments;
	},
	getCurrentName: (state) => {
		return state.name;
	},
	getCurrentId: (state) => {
		return state.id;
	},
	myDepartments(state) {
		return state.myDepartments;
	},
	transferPermittedDepartments(state) {
		return state.transferPermittedDepartments
	}
};


const actions = {
	async getDepartmentsList({commit}) {
		try {
			const res = await DepartmentsService.getDepartments();
			commit('setDepartments', res.data);
			return true
		} catch (e) {
			return false
		}
	},
	async getDepartmentsForContragent({commit}) {
		try {
			const response = await DepartmentsService.getDepartmentsWithRequisite();
			commit('setDepartmentsWithRequisite', response.data);
			return true
		} catch (e) {
			return false
		}
	},
	setCurrentActions({commit}, model) {
		commit('setCurrentId', model.id);
		commit('setCurrentName', model.name);
	},
	async updateOrCreateChildDep({commit}, payload) {
		try {
			const updateResponse = await DepartmentsService.updateOrCreateDepChildById(payload);
			commit('updateOrCreateChildDepCommit', updateResponse.data);
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('addDepError', {message: response.message, boolean: true});
			return false;
		}

	},
	async deleteDep({commit}, id) {
		try {
			const deleteResponse = await DepartmentsService.deleteDep(id);
			commit('deleteDepFromStore', {deleteResponse, id});
			return true;
		} catch (e) {
			let response = JSON.parse(e.request.response);
			commit('deleteDepError', {message: response.message, boolean: true});
			return false;
		}
	},

	async fetchMyDepartments({commit}) {
		try {
			const getResponse = await UsersService.getPermittedDepartments();
			commit('setMyDepartments', getResponse.data.permittedDepartments)
			commit('setTransferPermittedDepartments', getResponse.data.transferPermittedDepartments)
		} catch (e) {
			return false;
		}
	},

	async fetchWholesaleDepartments({commit}) {
		try {
			const getResponse = await DepartmentsService.fetchWholesaleDepartments();
			commit('setWholesaleDepartments', getResponse.data);
		} catch (e) {
			return false;
		}
	},
};

const mutations = {
	setDepartments(state, departments) {
		state.departments = departments;
	},
	setTransferPermittedDepartments(state, departments) {
		state.transferPermittedDepartments = departments
	},
	setDepartmentsWithRequisite(state, departmentsWithRequisite) {
		state.departmentsWithRequisite = departmentsWithRequisite;
	},
	updateOrCreateChildDepCommit(state, updateResponse) {
		state.depChildResponse = updateResponse
	},
	deleteDepFromStore(state, obj) {

	},
	setCurrentName(state, name) {
		state.name = name;
	},
	setCurrentId(state, id) {
		state.id = id;
	},
	addDepError(state, payload) {
		state.addDepError = payload.boolean;
		state.addDepErrorMessages = payload.message;
	},
	deleteDepError(state, payload) {
		state.notAllowedErrorDep = payload.boolean;
		state.deleteDepErrorMessage = payload.message;
	},
	setMyDepartments(state, data) {
		state.myDepartments = data;
	},
	setWholesaleDepartments(state, data) {
		state.wholesaleDepartments = data;
	},
	setFromDepId(state, payload) {
			state.fromDepId = payload;
	}
};

export const departments = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
